export type EventListener<TListenerPayload> = (
  args: TListenerPayload | undefined
) => void

export class EventEmitter<TListenerPayload> {
  private events: Map<string, Set<EventListener<TListenerPayload>>> = new Map()

  emit(eventName: string, args?: TListenerPayload): void {
    const listeners = this.events.get(eventName)
    if (listeners) {
      listeners.forEach((listener) => {
        listener(args)
      })
    }
  }

  addListener(
    eventName: string,
    listener: EventListener<TListenerPayload>
  ): void {
    if (!this.events.has(eventName)) {
      this.events.set(eventName, new Set())
    }
    this.events.get(eventName)!.add(listener)
  }

  removeListener(
    eventName: string,
    listener: EventListener<TListenerPayload>
  ): void {
    const listeners = this.events.get(eventName)
    if (listeners) {
      listeners.delete(listener)
      if (listeners.size === 0) {
        this.events.delete(eventName)
      }
    }
  }
}
